import React from 'react';
import { Result, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

const ErrorState = ({ onRetry, isDarkMode }) => {
  return (
    <div className={`error-state ${isDarkMode ? 'dark' : 'light'}`}>
      <Result
        status="error"
        title="Failed to Load Posts"
        subTitle="Something went wrong while loading the feed. Please try again."
        extra={[
          <Button
            key="retry"
            type="primary"
            icon={<ReloadOutlined />}
            onClick={onRetry}
            size="large"
          >
            Try Again
          </Button>
        ]}
      />
    </div>
  );
};

export default ErrorState;
